module.exports = __webpack_public_path__ + "img/add-debit-card.3bd1d188.jpg";